<template>
	<Button
		class="flex h-11 items-center gap-2 px-4 py-2"
		variant="primary"
		size="sm"
	>
		<slot name="icon" />
		<slot />
	</Button>
</template>
